export default __webpack_public_path__ + "static/media/delete.c6fb9713.svg";